module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0149.jpg?v=39c4f2ab";